import { render, staticRenderFns } from "./StaticRoadsTable.vue?vue&type=template&id=3090780f&"
import script from "./StaticRoadsTable.vue?vue&type=script&lang=js&"
export * from "./StaticRoadsTable.vue?vue&type=script&lang=js&"
import style0 from "./StaticRoadsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports